<template>
<form @submit.prevent="addData($event)">
<b-card class="">
<b-row>
<b-col style="padding-bottom:50px;" :md="4">
    <label class="sr-only" for="inline-form-input-name">نام</label>
    <b-form-input  name="name" id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
<br>
    <b-form-checkbox
      id="selectAll"
      v-model="selectAll"
      name="fullAccess">&nbsp;افزودن همه  &nbsp;  </b-form-checkbox>

</b-col>
<br>
</b-row>
<b-row>
<b-col style="padding-bottom:50px;" :md="4" v-for="(row,key) in permissions">
<h6>*{{ row.title }}
</h6>
<div  v-for="(access,index) in row.access">

    <b-form-checkbox
     :name="'access['+key+']['+index+']'"
     value="1"
      unchecked-value="not_accepted"
    >&nbsp;
{{access}}  &nbsp;  </b-form-checkbox>

  </div>
</b-col>
<br>
</b-row>
   <button type="submit" class="btn btn-fill btn-success">
                ذخیره
              </button>
  </b-card>

          </form>

</template>

<script>
export default {
  data() {
    return {
      permissions:[],
      access:[],
      selectAll:false
    };
  },
  methods: {
    async getData() {
      let _this = this;
      this.$store.state.loading = true;
      let url = `/roles/permissions`;
      await axios
        .get(url)
        .then(function (response) {
          _this.permissions=response.data;
         
        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },
    addData(event) {
      let _this = this;
      let data = new FormData(event.target);
      _this.$root.loading = true;

      axios
        .post("/roles/add", data)
        .then(function (response) {
          _this.$root.loading = false;
          _this.$toast.success("سطح دسترسی با موفقیت ذخیره شد");
          _this.$router.push("/roles/list");
        })
        .catch(function (err) {
          _this.$root.loading = false;
          _this.$root.handleAxiosError(err);
        });
    },
  },
  mounted() {
    this.getData();
  },
  watch:{
    selectAll(){
       let checkboxes= document.getElementsByTagName('input');
         for(var i=0, n=checkboxes.length;i<n;i++) {
            checkboxes[i].checked = this.selectAll;
            }
       
    }
  }
};
</script>

<style scope>

</style>
